import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';

import {PageWrapperContent} from 'presentation/components';
import {HomeEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useOperationalCostStore} from 'presentation/hooks/useOperationalCostPassword/store';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {useAccountInformation} from '../hooks';

export function AuthorizationsWrapper() {
	const {canOpenService, serviceTypeByPath} = useServicePermission();
	const {odontoOnly, isResponsibleWithoutBenefits, isEarlyAccess} = useAccountInformation();
	const {pathname} = useLocation();
	const isOperationalCostAuthorizated = useOperationalCostStore(
		state => state.isOperationalCostAuthorized,
	);
	const serviceType = serviceTypeByPath(pathname);
	const {isValid} = useContractStatus();

	const canAccessAuthorizationsService =
		isValid && !isResponsibleWithoutBenefits && !odontoOnly && !isEarlyAccess;

	useEffect(() => {
		if (!canAccessAuthorizationsService) return;
		if (!isOperationalCostAuthorizated) {
			canOpenService(serviceType);
		}
	}, [pathname, isOperationalCostAuthorizated]);

	if (!canAccessAuthorizationsService) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperContent />;
}
